export const FREE_FORM_LESSON_UUID = 'pc_free_form_lesson';
